import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const setupDimension = ({ dimension, dimensionStore }) => ({
  type: types.SETUP_DIMENSION,
  dimension,
  dimensionStore,
});

const unsetDimension = (dimension) => ({
  type: types.UNSET_DIMENSION,
  dimension,
});

const initBenchmark = (dimension) => ({
  type: types.INIT_BENCHMARK,
  dimension,
});

const initBenchmarkSPI = () => ({
  type: types.INIT_BENCHMARK_SPI,
});

const setResponse = ({ dimension, response, errorMsg }) => ({
  type: types.SET_RESPONSE,
  dimension,
  response,
  errorMsg,
});

const {
  init: initBenchmarkKPI,
  fetching: setKPIFetchingState,
  setResponse: setKPIResponse,
  abortFetching: abortKPIFetching,
} = createAllActions(types.IMP_BENCHMARK_KPI);
const {
  fetching: setSPIFetchingState,
  setResponse: setSPIResponse,
  abortFetching: abortSPIFetching,
} = createAllActions(types.IMP_BENCHMARK_SPI);
const { init: initSupportedMetrics, fetching: fetchSupportedMetrics } = createAllActions(types.SUPPORTED_METRICS);

export {
  init,
  fetching,
  initBenchmark,
  setKPIFetchingState,
  setKPIResponse,
  abortKPIFetching,
  setSPIResponse,
  abortSPIFetching,
  setSPIFetchingState,
  initBenchmarkSPI,
  initBenchmarkKPI,
  setResponse,
  setupDimension,
  unsetDimension,
  initSupportedMetrics,
  fetchSupportedMetrics,
}
